"use client";
import { useParams } from "react-router-dom";
import styles from "../styles/home.module.css";
import flatInfo from "../data/FlatInfo";
import { useState } from "react"; 

const ApartmentDetails = () => {
    const { id } = useParams();
    const flat = flatInfo.find(apartment => apartment.id === Number(id));
    const [activeTab, setActiveTab] = useState("costBreakdown");

    if (!flat) {
        return <p>No apartment details available.</p>;
    }

    return (
        <div className={styles.apartmentContainer}>
            <h1 className={styles.apartmentTitle}>{flat.title}</h1>

            {/* Apartment Image Gallery */}
            <div className={styles.gallery}>
                <div className={styles.imageGrid}>
                    {flat.imageSources.map((src, index) => (
                        <img key={index} src={src} alt={`Apartment ${index + 1}`} className={styles.image} />
                    ))}
                </div>
            </div>

            <div className={styles.apartmentDetails}>
                <h3 className={styles.apartmentSubtitle}>৳ {flat.costBreakdown.main.monthly.required[0].value} /mo</h3>
                <p>{flat.subtitle}</p>

                <div className={styles.tags}>
                    {flat.additionals.map((item, index) => (
                        <span key={index} className={styles.tag}>
                            {item.roomDetails} - {item.additionalValue}
                        </span>
                    ))}
                </div>
            </div>

            {/* Tabs */}
            <div className={styles.tabs}>
                <button
                    className={`${styles.tab} ${activeTab === "costBreakdown" ? styles.tabActiveAp : styles.tabInactiveAp}`}
                    onClick={() => setActiveTab("costBreakdown")}
                >
                    Cost Breakdown
                </button>
                <button
                    className={`${styles.tab} ${activeTab === "rentDetails" ? styles.tabActiveAp : styles.tabInactiveAp}`}
                    onClick={() => setActiveTab("rentDetails")}
                >
                    Rent Details
                </button>
            </div>

            {/* Tab Content */}
            <div className={styles.tabContent}>
  {activeTab === "costBreakdown" ? (
    <div className={styles.costBreakdown}>
      <h3 className={styles.sectionTitle}>One-Time Costs:</h3>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Description</th>
            <th>Amount (৳)</th>
          </tr>
        </thead>
        <tbody>
          {flat.costBreakdown.main.oneTime.required.map((cost, index) => (
            <tr key={index}>
              <td>{cost.description}</td>
              <td>{cost.value}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3 className={styles.sectionTitle}>Monthly Costs:</h3>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Description</th>
            <th>Amount (৳)</th>
          </tr>
        </thead>
        <tbody>
          {flat.costBreakdown.main.monthly.required.map((cost, index) => (
            <tr key={index}>
              <td>{cost.description}</td>
              <td>{cost.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <div className={styles.rentDetails}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Room Type</th>
            <th>Additional Value</th>
          </tr>
        </thead>
        <tbody>
          {flat.additionals.map((room, index) => (
            <tr key={index}>
              <td>{room.roomDetails}</td>
              <td>{room.additionalValue}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )}
</div>

        </div>
    );
};

export default ApartmentDetails;

